// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"91a0c605","162":"b5625e7d","787":"49d3cda4","957":"36a6b521","966":"1c2c5582"}[chunkId] + ".chunk.js";
};